import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronRight, Home, MapPin, Phone, Mail, Clock, Globe, Facebook, Twitter, Linkedin, Youtube, Send } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
const offices = [{
  name: 'Ministry Headquarters',
  address: 'Plot 16-18 Lugard Avenue, P.O. Box 102, Entebbe, Uganda',
  phone: ['+256 414 320 004', '+256 414 320 115'],
  tollFree: '0800 100 987',
  email: 'info@agriculture.go.ug',
  hours: 'Monday – Friday: 8:00 AM – 5:00 PM'
}, {
  name: 'Kampala Liaison Office',
  address: 'Farmers House, Parliament Avenue, Kampala',
  phone: ['+256 414 233 864'],
  tollFree: null,
  email: 'kampala@agriculture.go.ug',
  hours: 'Monday – Friday: 8:00 AM – 5:00 PM'
}];
export function ContactPage() {
  return <>
      <Header data-id="element-655" />
      <main className="flex-grow pt-[160px] md:pt-[148px] bg-gray-50 pb-20" data-id="element-656">
        <div className="relative text-white py-32 md:py-48 overflow-hidden" data-id="element-657">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1560493676-04071c5f467b?w=1600&h=600&fit=crop")'
        }} data-id="element-658"></div>
          <div className="absolute inset-0 bg-uganda-green/80" data-id="element-659"></div>
          <div className="relative max-w-7xl mx-auto px-4 md:px-8" data-id="element-660">
            <div className="flex items-center text-sm text-green-100 mb-6" data-id="element-661">
              <Link to="/" className="hover:text-white flex items-center" data-id="element-662">
                <Home className="w-4 h-4 mr-1" data-id="element-663" /> Home
              </Link>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-664" />
              <span data-id="element-665">About MAAIF</span>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-666" />
              <span className="text-white font-medium" data-id="element-667">Contact Us</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-668">Contact Us</h1>
            <p className="text-lg text-green-50 max-w-3xl leading-relaxed" data-id="element-669">
              Get in touch with the Ministry of Agriculture, Animal Industry and
              Fisheries. We're here to help.
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-8 mt-12" data-id="element-670">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-671">
            {/* Contact Form */}
            <div className="lg:col-span-2" data-id="element-672">
              <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8" data-id="element-673">
                <h2 className="text-2xl font-bold text-uganda-black mb-6" data-id="element-674">
                  Send Us a Message
                </h2>
                <form className="space-y-5" onSubmit={e => e.preventDefault()} data-id="element-675">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-676">
                    <div data-id="element-677">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-678">
                        Full Name *
                      </label>
                      <input type="text" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-uganda-green focus:border-transparent" placeholder="Your full name" data-id="element-679" />
                    </div>
                    <div data-id="element-680">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-681">
                        Email Address *
                      </label>
                      <input type="email" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-uganda-green focus:border-transparent" placeholder="you@example.com" data-id="element-682" />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-683">
                    <div data-id="element-684">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-685">
                        Phone Number
                      </label>
                      <input type="tel" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-uganda-green focus:border-transparent" placeholder="+256 7XX XXX XXX" data-id="element-686" />
                    </div>
                    <div data-id="element-687">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-688">
                        Subject *
                      </label>
                      <select className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-uganda-green focus:border-transparent text-gray-700" data-id="element-689">
                        <option value="" data-id="element-690">Select a subject</option>
                        <option data-id="element-691">General Inquiry</option>
                        <option data-id="element-692">Import/Export Permits</option>
                        <option data-id="element-693">Complaints & Feedback</option>
                        <option data-id="element-694">Partnership Opportunities</option>
                        <option data-id="element-695">Media Inquiry</option>
                        <option data-id="element-696">Other</option>
                      </select>
                    </div>
                  </div>
                  <div data-id="element-697">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-698">
                      Message *
                    </label>
                    <textarea rows={5} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-uganda-green focus:border-transparent resize-none" placeholder="How can we help you?" data-id="element-699" />
                  </div>
                  <button type="submit" className="inline-flex items-center gap-2 bg-uganda-green text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-800 transition-colors" data-id="element-700">
                    <Send className="w-4 h-4" data-id="element-701" /> Send Message
                  </button>
                </form>
              </div>
            </div>

            {/* Sidebar */}
            <div className="space-y-6" data-id="element-702">
              {offices.map((office, index) => <motion.div key={office.name} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-703">
                  <h3 className="font-bold text-lg text-uganda-black mb-4" data-id="element-704">
                    {office.name}
                  </h3>
                  <div className="space-y-3 text-sm" data-id="element-705">
                    <div className="flex items-start gap-3" data-id="element-706">
                      <MapPin className="w-4 h-4 text-uganda-green mt-0.5 flex-shrink-0" data-id="element-707" />
                      <span className="text-gray-600" data-id="element-708">{office.address}</span>
                    </div>
                    {office.phone.map((p, i) => <div key={i} className="flex items-center gap-3" data-id="element-709">
                        <Phone className="w-4 h-4 text-uganda-green flex-shrink-0" data-id="element-710" />
                        <span className="text-gray-600" data-id="element-711">{p}</span>
                      </div>)}
                    {office.tollFree && <div className="flex items-center gap-3" data-id="element-712">
                        <Phone className="w-4 h-4 text-uganda-yellow flex-shrink-0" data-id="element-713" />
                        <span className="text-gray-600 font-semibold" data-id="element-714">
                          Toll-Free: {office.tollFree}
                        </span>
                      </div>}
                    <div className="flex items-center gap-3" data-id="element-715">
                      <Mail className="w-4 h-4 text-uganda-green flex-shrink-0" data-id="element-716" />
                      <span className="text-gray-600" data-id="element-717">{office.email}</span>
                    </div>
                    <div className="flex items-center gap-3" data-id="element-718">
                      <Clock className="w-4 h-4 text-uganda-green flex-shrink-0" data-id="element-719" />
                      <span className="text-gray-600" data-id="element-720">{office.hours}</span>
                    </div>
                  </div>
                </motion.div>)}

              <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-721">
                <h3 className="font-bold text-lg text-uganda-black mb-4" data-id="element-722">
                  Follow Us
                </h3>
                <div className="flex gap-3" data-id="element-723">
                  {[{
                  icon: Facebook,
                  label: 'Facebook'
                }, {
                  icon: Twitter,
                  label: 'Twitter'
                }, {
                  icon: Linkedin,
                  label: 'LinkedIn'
                }, {
                  icon: Youtube,
                  label: 'YouTube'
                }].map(({
                  icon: Icon,
                  label
                }) => <a key={label} href="#" className="w-10 h-10 rounded-full bg-uganda-light-green text-uganda-green flex items-center justify-center hover:bg-uganda-green hover:text-white transition-colors" title={label} data-id="element-724">
                      <Icon className="w-5 h-5" data-id="element-725" />
                    </a>)}
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-726">
                <h3 className="font-bold text-lg text-uganda-black mb-3" data-id="element-727">
                  Website
                </h3>
                <a href="https://www.agriculture.go.ug" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-uganda-green font-semibold hover:text-green-800 transition-colors text-sm" data-id="element-728">
                  <Globe className="w-4 h-4" data-id="element-729" /> www.agriculture.go.ug
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-730" />
    </>;
}